<template>
  <div class="ace-grain-beans-step-2 ace-content">
    <Header :images="feedMaterial.images" :title="feedMaterial.title"/>
    <h2 class="ace-grain-beans-step-2__title">Please enter your details here</h2>
    <form class="ace-grain-beans-step-2__form ace-form">
      <div class="ace-form__row">
        <div class="ace-form__field">
          <label class="ace-form__label">Tonnes of {{ feedMaterial.name }}</label>
          <div class="ace-form__input">
            <input
                type="number"
                min="1000"
                max="200000"
                step="1000"
                v-model="feedMaterial.weight"
            />
          </div>
        </div>
      </div>
      <div class="ace-form__row">
        <div class="ace-form__field">
          <label class="ace-form__label">Moisture at Harvest</label>
          <div class="ace-form__input ace-form__input--select">
            <select v-model="feedMaterial.moisture">
              <option v-for="value in moistureValues" :key="value" :value="value">
                {{ value }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="ace-form__row">
        <div class="ace-form__field">
          <label class="ace-form__label">Fuel source if drying</label>
          <div class="ace-form__input ace-form__input--select">
            <select @change="$emit('setFuel', $event.target.value)">
              <option v-for="(value, key) in fuelOptions" :key="key" :value="key">
                {{ value }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </form>
    <Divider/>
    <div class="ace-grain-beans-step-2__estimated">
      <h2 class="ace-grain-beans-step-2__title">Estimated Carbon Footprint</h2>
      <ul :class="`ace-grain-beans-step-2__estimated-results--${estimatedResults.length}`">
        <li
            v-for="(estimatedResult, index) in estimatedResults"
            class="ace-grain-beans-step-2__estimated-result"
            :key="index"
        >
          <Result
              :name="estimatedResult.name"
              :value="estimatedResult.totalEfPerTonne"
              unit="kg CO2-eq/tonne DM"
          />
        </li>
      </ul>
    </div>
    <ButtonGroup>
      <Button variant="dark" icon="arrow" text="See detailed results" @click="$emit('nextStep')"/>
    </ButtonGroup>
  </div>
</template>

<script>
import fuelOptions from './_fuelOptions';

import Header from '../Layout/Header.vue';
import ButtonGroup from '../Layout/ButtonGroup.vue';
import Button from '../Layout/Button.vue';
import Divider from '../Layout/Divider.vue';
import Result from '../Layout/Result.vue';

export default {
  data() {
    return {
      fuelOptions,
    };
  },
  props: ['feedMaterial', 'fuel', 'efBreakdown', 'resultsToShow'],
  computed: {
    moistureValues() {
      // it's returns strings
      return [...Array(23).keys()].map(key => ((key + 28) * 0.5).toFixed(1));
    },
    estimatedResults() {
      return this.resultsToShow.map(result => this.efBreakdown[result]);
    },
  },
  components: {
    Header,
    ButtonGroup,
    Button,
    Divider,
    Result,
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/mixins';

.ace-grain-beans-step-2 {
  max-width: 980px;
  @media screen and (min-width: 767px) {
    padding: 0 60px;
  }

  &__title {
    @include title;

    margin-top: 55px;
  }

  &__form {
    margin: 25px auto 45px;

    display: flex;
    flex-direction: column;

    column-gap: 30px;
    @media screen and (min-width: 767px) {
      flex-direction: row;
    }

    .ace-form__row {
      & + .ace-form__row {
        @media screen and (min-width: 767px) {
          margin-top: 0;
        }
      }
    }
  }

  &__estimated {
    $this: &;

    margin-bottom: 60px;

    &-results {
      margin: 40px 0 0;
      padding: 0;

      display: grid;

      list-style-type: none;

      column-gap: 30px;
      row-gap: 30px;
      grid-template-columns: repeat(1, minmax(0, 1fr));

      &--2 {
        @extend .ace-grain-beans-step-2__estimated-results;
        @media screen and (min-width: 767px) {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
      }

      &--3 {
        @extend .ace-grain-beans-step-2__estimated-results;
        @media screen and (min-width: 767px) {
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }
      }
    }
  }
}
</style>
